import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateBlockDateActions } from "store/ducks/settings/block-dates";

export function* updateBlockDateRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/block-dates/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateBlockDateActions.success(data));
    notify("success", "Horário atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateBlockDateActions.failure(errorMessage));
  }
}
